import { Box, styled } from '@mui/material';

export const ViewAllContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 16,
  flexGrow: 1,
  width: '100%',
  maxWidth: '1000px',
  margin: '0 auto',
});

export const ViewAllHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: 1.25,
});

export const TableContainer = styled(Box)({
  width: '100%',
  paddingBottom: '66px',
});
